import { useEffect } from "react";
import { getConfig } from "@/lib/affiliate";

// Injects Skimlinks + Google AdSense scripts on the fly if publisher IDs
// exist in the backend config. Silently no-ops when the IDs are blank.
export default function ThirdPartyScripts() {
  useEffect(() => {
    (async () => {
      const cfg = await getConfig();

      // Skimlinks — auto-affiliates outbound links across ~24k merchants
      if (cfg.skimlinks_publisher_id && !document.getElementById("skimlinks-script")) {
        const s = document.createElement("script");
        s.id = "skimlinks-script";
        s.async = true;
        s.src = `https://s.skimresources.com/js/${cfg.skimlinks_publisher_id}.skimlinks.js`;
        document.head.appendChild(s);
      }

      // Google AdSense — bootstrap loader
      if (cfg.adsense_publisher_id && !document.getElementById("adsense-script")) {
        const s = document.createElement("script");
        s.id = "adsense-script";
        s.async = true;
        s.crossOrigin = "anonymous";
        s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-${cfg.adsense_publisher_id}`;
        document.head.appendChild(s);
      }
    })();
  }, []);

  return null;
}
